import { lazy, Suspense } from 'react';
import { Navigate, useParams, type RouteObject } from 'react-router';
import { PageSkeleton } from '../../components/Page';

const IntelligencePage = lazy(() => import('./IntelligencePage'));

/** Caminhos antigos do plano (/inteligencia/produtos, /estoque...) viram a aba correspondente. */
const LEGACY: Record<string, string> = {
  produtos: 'matriz',
  matriz: 'matriz',
  ranking: 'ranking',
  combinacoes: 'juntos',
  juntos: 'juntos',
  estoque: 'estoque',
  grade: 'grade',
};

function LegacyRedirect() {
  const { '*': rest = '' } = useParams();
  const first = rest.split('/')[0] ?? '';
  const tab = LEGACY[first];
  return <Navigate to={tab ? `/inteligencia?aba=${tab}` : '/inteligencia'} replace />;
}

/** Rotas desta área (dentro do shell autenticado). */
export const routes: RouteObject[] = [
  {
    path: 'inteligencia',
    element: (
      <Suspense fallback={<PageSkeleton variant="dashboard" />}>
        <IntelligencePage />
      </Suspense>
    ),
  },
  { path: 'inteligencia/*', element: <LegacyRedirect /> },
];

/** Rotas protegidas sem o shell (ex.: impressão). */
export const fullscreenRoutes: RouteObject[] = [];
